import React from 'react';

export default function Thank() {
  return (
    <section>
      <h1>Merci de votre attention !</h1>
    </section>
  );
}
